import React, {Component, Fragment} from 'react';
import {BreadcrumbsItem} from "react-breadcrumbs-dynamic";
import {withTranslation} from "react-i18next";
import {Route, Routes} from "react-router-dom";
import {route} from "../../../routes";
import JobDetailView from "./JobDetailView";
import JobRoleView from "./JobRoleView";
import JobPayView from "./JobPayView";
import JobBecomeView from "./JobBecomeView";
import JobSkillsView from "./JobSkillsView";
import {GelContentContainer, NotFound} from "cw-styleguide-react";

class JobView extends Component {
  render() {
    return (
      <Fragment>
        <BreadcrumbsItem to={route('job', {job: this.props.data.slug})}>
          {this.props.data.name}
        </BreadcrumbsItem>
        <Routes>
          <Route index element={<JobDetailView {...this.props}/>} />
          <Route path={route('jobRole')} element={<JobRoleView {...this.props}/>}/>
          <Route path={route('jobPay')} element={<JobPayView {...this.props}/>}/>
          <Route path={route('jobBecome')} element={<JobBecomeView {...this.props}/>}/>
          <Route path={route('jobSkills')} element={<JobSkillsView {...this.props}/>}/>
          <Route path="*" element={<GelContentContainer><NotFound/></GelContentContainer>}/>
        </Routes>
      </Fragment>
    );
  }
}

export default withTranslation('local')(JobView);
